import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { FormType, FormPayloadType } from "@/common/types/form";

export async function formList(account_id: string, query?: QueryType) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(`account/${account_id}/form/list${queryString}`);
}

export async function formGet(account_id: string, form_id: string) {
  return await clientAxios.get(`account/${account_id}/form/${form_id}/show`);
}

export async function formAdd(account_id: string, payload: FormPayloadType) {
  return await clientAxios.post(`account/${account_id}/form/create`, payload);
}

export async function formPut(
  account_id: string,
  form_id: string,
  payload: FormPayloadType,
) {
  return await clientAxios.put(
    `account/${account_id}/form/${form_id}/update`,
    payload,
  );
}

export async function formPatch(
  account_id: string,
  form_id: string,
  payload: Partial<FormType>,
) {
  return await clientAxios.patch(
    `account/${account_id}/form/${form_id}/patch`,
    { payload },
  );
}

export async function formDel(account_id: string, form_id: string) {
  return await clientAxios.del(`account/${account_id}/form/${form_id}/delete`);
}
